import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { Header } from '../../../../common/ui/styled';
import messages from './messages';
import type { TimeZone } from './types';

type TimezoneViewProps = {
	timezone: TimeZone;
};

const TimezoneView = ({ timezone }: TimezoneViewProps) => {
	const { formatMessage } = useIntl();
	if (!timezone) {
		return null;
	}

	const { label } = timezone;
	return (
		<>
			<Header>
				{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
				<h2> {formatMessage(messages.timezoneHeader)}</h2>
			</Header>
			<TimezoneValue data-test-id="servicedesk-sla-settings.ui.calendars.calendar.timezone">
				{label}
			</TimezoneValue>
		</>
	);
};

export const Timezone = TimezoneView;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TimezoneValue = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.DN0),
	marginTop: token('space.100', '8px'),
});
